import React from 'react';
import Typography from '@hpstellar/core/Typography';

import BadgeContainer from '../../main/components/badge-container';
import BadgeBanner from '../../main/components/badge-banner';
import ModelList from './model-list';

import './mlp.less';


const MLP = ({ modelList, titleSection }) => {
    const { title, badges = [] } = titleSection || {};
    return <div className={'mlp'}>
        <div className={'title-section'}>
            <Typography
                tag="h1"
                variant="headingTitleLarge">
                {title}
            </Typography>
            <BadgeBanner
                className={'badge-header'}
                showFor={['desktop']}
            >
                {
                    badges.map(b => <BadgeContainer key={b.key} customMessage={b.text ? [b.text] : null} />)
                }
            </BadgeBanner>
        </div>
        <ModelList models={modelList} />
        <BadgeBanner
            className={'badge-header'}
            showFor={['mobile', 'tablet']}
        >
            {
                badges.map(b => <BadgeContainer key={b.key} customMessage={b.text ? [b.text] : null} />)
            }
        </BadgeBanner>
    </div>;
}

export default MLP;